import { LinearProgress, MuiThemeProvider } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTheme, getAssetHistory, handleUserSession } from '../actions';
import DashboardHistory from '../components/DashboardHistory';
import { useParams } from 'react-router-dom';

function DashboardHistoryContainer (state) {
  const { id } = useParams();
  const [asset, setAsset] = useState([]);

  useEffect(() => {
    const loadDashboardHistory = async () => {
      const token = await handleUserSession();
      const response = await getAssetHistory(token, id);
      setAsset(response);
    };
    loadDashboardHistory();
  }, [id]);

  return (
    <MuiThemeProvider theme={getTheme()}>
      <>
        {asset !== [] && state.configFile !== undefined
          ? <DashboardHistory configFile={state.configFile} assets={asset} />
          : <LinearProgress />}
      </>
    </MuiThemeProvider>
  );
}

const mapStateToProps = state => ({
  assets: state.assets,
  configFile: state.configFile
});

export default connect(mapStateToProps, null)(DashboardHistoryContainer);
